import { SlideDTO, OptionDTO } from './lesson.types';

// Slide types enum
export enum SlideType {
  QUESTION = 'QUESTION',
  VIDEO_PREVIEW = 'VIDEO_PREVIEW',
  INFO = 'INFO',
  IMAGE_UPLOAD = 'IMAGE_UPLOAD',
  TEXT = 'TEXT',
}

// Slide data interface
export interface SlideData extends SlideDTO {
  // Additional frontend properties
  isNew?: boolean;
  isDirty?: boolean;
}

// Option data interface
export interface OptionData extends OptionDTO {
  // Additional frontend properties
  isNew?: boolean;
  isDirty?: boolean;
}

// Validation result interface
export interface ValidationResult {
  valid: boolean;
  errors: string[];
  warnings?: string[];
}

// Slide capabilities interface
export interface SlideCapabilities {
  hasOptions?: boolean;
  hasImage?: boolean;
  hasText?: boolean;
  hasVideo?: boolean;
  requiresUpload?: boolean;
  isScoreable?: boolean;
  supportsTimeLimit?: boolean;
  maxOptions?: number;
  minOptions?: number;
}

// Props for slide creation component
export interface SlideCreationProps {
  slide: SlideData;
  errors?: Record<string, string>;
  onChange: (updates: Partial<SlideData>) => void;
  onImageUpload?: (file: File) => Promise<string>;
  isPreview?: boolean;
}

// Props for slide completion component
export interface SlideCompletionProps {
  slide: SlideData;
  answer: any;
  onAnswer: (updates: any) => void;
  isSubmitting?: boolean;
  isPreview?: boolean;
}

// Props for slide preview component
export interface SlidePreviewProps {
  slide: SlideData;
  answer?: any;
}

// Props for slide report component
export interface SlideReportProps {
  slide: SlideData;
  answer: any;
  showCorrectAnswers?: boolean;
}